var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.086,
    height: 94.098,
    viewBox: "0 0 91.086 94.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2773",
    "data-name": "Group 2773",
    transform: "translate(-2679.116 -6804.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    transform: "translate(-814.211 -1096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M3523.125,7958.65V7901h57.925v68.831",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M3531.024,7930.024a43.363,43.363,0,0,0,9.181,1.378c4.017,0,8.034-2.569,8.034-5.738s-5.624-5.165-8.034-5.739-8.034-2.569-8.034-5.738,4.017-5.739,8.034-5.739a63.692,63.692,0,0,1,9.182.917",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_818",
    "data-name": "Line 818",
    x2: 0.113,
    y2: 31.332,
    transform: "translate(3540.205 7904.774)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_819",
    "data-name": "Line 819",
    x2: 21.289,
    transform: "translate(3553.617 7907.057)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_820",
    "data-name": "Line 820",
    x2: 21.289,
    transform: "translate(3553.617 7915.482)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_821",
    "data-name": "Line 821",
    x2: 21.289,
    transform: "translate(3553.617 7923.907)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_822",
    "data-name": "Line 822",
    x2: 21.289,
    transform: "translate(3553.617 7932.332)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_823",
    "data-name": "Line 823",
    x2: 44.869,
    transform: "translate(3530.037 7943.182)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    x2: 44.869,
    transform: "translate(3530.037 7951.607)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 12.937,
    height: 19.885,
    transform: "translate(3528.967 7961.65)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M3541.308,7964.5s6.4.133,9.456.133,8.031.994,11.013,2.983,0,7.954-4.971,5.965",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M3551.835,7971.593s8.948,3.977,12.925,3.977,8.746-3.052,11.352-4.474c4.556-2.486,6.91-1.39,7.539.5.994,2.983-2.983,5.965-4.971,6.96s-7.954,3.977-13.92,3.977-11.931-3.977-16.9-3.977-5.96,0-5.96,0",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(3493.327 7948.5)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M3506.385,7970.735l5.647,7.765,16.235-12",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.ab60d5cfdf39d38e856b635ff1a8e9b5.svg";
export { ForwardRef as ReactComponent };